import React, { useState } from "react";
import { Link } from "react-router-dom";
import ComparisonDetalingTable from "./ComparisonDetalingTable";
import ComparisonDetalingSecondTable from "./ComparisonDetalingSecondTable";
import { useModal } from '../../../contexts/ModalContext';
import { BaseUrl } from "../../../helper/BaseUrl";
import { DateConvert } from "../../../helper/DateConvert";

export default function ComparisonDetalingContent({ data, author }) {
  const [activeSection, setActiveSection] = useState("");
  const { openQueryModal } = useModal();
  const [pageUrl, setPageUrl] = React.useState("");
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    if (typeof window !== "undefined" && pageUrl) {
      try {
        await navigator.clipboard.writeText(pageUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 10000);
      } catch (err) {
        console.error("Copy failed:", err);
      }
    }
  };

  return (
    <>
      <section className='ComparisonDetalingContent-area'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-3 col-md-4'>
              <div className='ComparisonDetalingContent-left'>
                <div className='ComparisonDetaling-guide'>
                  <span>IN THIS GUIDE:</span>
                  <ul>
                    {data?.sections?.map((section, index) => {
                      const sectionId = `section-${index + 1}`;
                      return (
                        <li key={index}>
                          <a href={`#${sectionId}`} className={activeSection === sectionId ? "active" : ""} onClick={() => setActiveSection(sectionId)}    >
                            {section.heading}
                          </a>
                        </li>
                      );
                    })}
                  </ul>

                </div>

                <div className="comparisondetaling-cta-area">
                  <div className="comparisondetaling-cta-inner">
                    <img src="/assets/images/comparisondetaling-star.webp" alt="Star" />
                    <span>CHOOSE WITH CONFIDENCE</span>
                  </div>
                  <label>Upgrade Your Logistics <br />Platform Today</label>
                  <p>Replace disconnected tools with one intelligent platform for fleet   management, shipment tracking, dispatch, and analytics.</p>

                  <Link className="theme-btn comparison-white-btn" onClick={openQueryModal}><span>Request A Demo</span></Link>
                  <small>Trusted By Growing Enterprises</small>
                </div>

              </div>
            </div>
            <div className='col-lg-9 col-md-8'>
              <div className='ComparisonDetalingContent-right'>
                <div className="content-wrap">
                  {data?.sections?.map((section, index) => {
                    const sectionId = `section-${index + 1}`;
                    return (
                      <div key={index}>
                        {section.heading && (
                          <h2 className="heading" id={sectionId}>  {section.heading}   </h2>)}
                        {section.description && (
                          <div className="section-content" dangerouslySetInnerHTML={{ __html: section.description }} />)}
                        {section.comparison_table_enabled && (
                          <ComparisonDetalingTable
                            tableData={section.comparison_table}
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
                <div className="comparisonDetalingcontent-author">
                  <div className="comparisonDetalingcontent-info">
                    <img src={BaseUrl + author?.image} className="img-responsive" alt={author?.name} />
                    <div className="author-info"><span>Written by {author?.name}</span> <p>Updated on {DateConvert(data?.date)}</p></div>
                  </div>
                  <div className="footer-social">
                    <ul className="social-items">
                      <li title={copied ? "Copied!" : "Copy link"}>
                        <Link to="#" onClick={handleCopy} rel="noopener noreferrer">  <i className="fa-solid fa-link"></i>  </Link>
                      </li>
                      <li>
                        <a target='_blank' rel="noopener noreferrer" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(pageUrl)}`}>
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-instagram"></i>
                        </a>
                      </li>
                      <li>
                        <a href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(pageUrl)}`} target="_blank" rel="noopener noreferrer">
                          <i className="fa-brands fa-x-twitter"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
